import { render, staticRenderFns } from "./InputControl.vue?vue&type=template&id=32c2b6d7&"
import script from "./InputControl.vue?vue&type=script&lang=js&"
export * from "./InputControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports